import { CampaignFormCustomer, NumbersList } from '../model/type';

export const NumberListToCustomersMapper = (data: NumbersList): CampaignFormCustomer[] => {
  return data.customers.map(
    (customer) =>
      ({
        number: customer.phone,
        name: customer.name,
        id: customer.id,
        createdAt: customer.createdAt,
        metadata: customer.metadata,
        attributes: customer.attributes,
      }) as CampaignFormCustomer,
  );
};
